import React, { useEffect, useState } from "react";
import { Heart, Check, Loader2 } from "lucide-react";

// Public page (no login) where invited loved ones leave a message of support.
export default function CarePage({ token }) {
  const [info, setInfo] = useState(undefined); // undefined=loading, null=not found
  const [fromName, setFromName] = useState("");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/gentle-space/public/${token}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setInfo).catch(() => setInfo(null));
  }, [token]);

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/gentle-space/support`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, fromName: fromName.trim(), text: text.trim() }),
      });
      if (!r.ok) throw new Error();
      setSent(true);
    } catch { /* silent */ }
    setBusy(false);
  };

  if (info === undefined) return <div className="flex min-h-screen items-center justify-center bg-ink"><Loader2 className="animate-spin text-brand" /></div>;
  if (info === null) return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-6 text-center">
      <p className="text-mist-muted">This space isn't available right now.</p>
    </div>
  );

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-6 py-12">
      <div className="glass w-full max-w-md rounded-[2rem] p-8 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand/12"><Heart size={24} className="text-brand-soft" /></div>
        {sent ? (
          <>
            <h1 className="mt-5 font-display text-2xl font-bold text-mist">Your love was delivered 💙</h1>
            <p className="mt-3 text-sm leading-relaxed text-mist-muted">{info.firstName} will see your message in their gentle space. Thank you for showing up for them.</p>
          </>
        ) : (
          <>
            <h1 className="mt-5 font-display text-2xl font-bold text-mist">Send love to {info.firstName}</h1>
            <p className="mt-2 text-sm leading-relaxed text-mist-muted">
              {info.firstName} is holding {info.babyName ? <span className="text-mist">{info.babyName}</span> : "their baby"} in their heart. A few gentle words from you can mean everything.
            </p>
            <div className="mt-6 space-y-3 text-left">
              <input data-testid="care-name" value={fromName} onChange={(e) => setFromName(e.target.value)} placeholder="Your name"
                className="w-full rounded-xl border border-white/10 bg-white/[0.03] px-4 py-2.5 text-sm text-mist placeholder:text-mist-muted/60 focus:border-brand/40 focus:outline-none" />
              <textarea data-testid="care-message" value={text} onChange={(e) => setText(e.target.value)} rows={4} placeholder="Write something gentle and true…"
                className="w-full resize-none rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-mist placeholder:text-mist-muted/60 focus:border-brand/40 focus:outline-none" />
            </div>
            <button data-testid="care-send" onClick={send} disabled={busy || !text.trim()}
              className="btn-primary mt-5 inline-flex w-full items-center justify-center gap-2 disabled:opacity-50">
              {busy ? <Loader2 size={16} className="animate-spin" /> : <Check size={16} />} Send your message
            </button>
          </>
        )}
        <p className="mt-6 text-[11px] tracking-wide text-mist-muted/70">WYVN · Win daily. Woven forever.</p>
      </div>
    </div>
  );
}
